var map = {
	"./bonus_symbol_0.png": "1905",
	"./bonus_symbol_1.png": "c5c4",
	"./bonus_symbol_2.png": "9f7fa",
	"./bonus_symbol_3.png": "c72b",
	"./bonus_symbol_4.png": "ddb4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "96e2";